var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheck2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22.8887C17.5228 22.8887 22 18.4115 22 12.8887C22 7.36582 17.5228 2.88867 12 2.88867C6.47715 2.88867 2 7.36582 2 12.8887C2 18.4115 6.47715 22.8887 12 22.8887ZM16.6339 11.2726C17.122 10.7844 17.122 9.99294 16.6339 9.50479C16.1457 9.01663 15.3543 9.01663 14.8661 9.50479L10.75 13.6209L9.13388 12.0048C8.64573 11.5166 7.85427 11.5166 7.36612 12.0048C6.87796 12.4929 6.87796 13.2844 7.36612 13.7726L9.86612 16.2726C10.3543 16.7607 11.1457 16.7607 11.6339 16.2726L16.6339 11.2726Z",
    fill: "#399D81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck2);
export default __webpack_public_path__ + "static/media/green-check-2.d68affb7e2c9556bbeff979752f5646d.svg";
export { ForwardRef as ReactComponent };